<template>
  <van-popup
    v-model="openPopUp"
    position="bottom"
    :style="{ height: '100%', background: '#EFEFF4'}"
    :get-container="getContainer"
  >
    <van-nav-bar
      title="所有图库"
      left-text="返回"
      left-arrow
      :style="{ background: '#5dadff'}"
      @click-left="back"
    />
    <div class="wrap">
      <div
        v-for="(group, index) in mapTukuTab"
        :key="`lottery-group-${group.code}-${index}`"
        class="filter"
      >
        <div class="filter-title">
          <img class="filter-icon" :src="group.src" alt="">
          <p class="title-lt" v-text="group.label"></p>
        </div>
        <ul class="filter-game">
          <li
            v-for="(child, childIndex) in group.children"
            :key="`lottery-group-${group.code}-${index}-${child.lotteryCode}-${childIndex}`"
            class="filter-game__item"
          >
            <a
              class="item-link"
              @click="switchLottery(child)"
              v-text="child.name"
            >
            </a>
          </li>
        </ul>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapTukuTab } from '@/utils/drawCanvas/common'

export default {
  name: 'NewspaperPopUpContent',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      openPopUp: false
    }
  },
  computed: {
    cpTypeDetail() {
      const sixhc = this.$store.state.lottery.liuHeDetail
      const pk10 = this.$store.state.lottery.pk10Detail
      const ssc = this.$store.state.lottery.sscDetail
      return {
        sixhc,
        pk10,
        ssc
      }
    },
    tukuTabs() {
      return {
        sixhc: this.$store.state.site.wapTukuTab.sixhcTukuTab,
        pk10: this.$store.state.site.wapTukuTab.pk10TukuTab,
        ssc: this.$store.state.site.wapTukuTab.sscTukuTab
      }
    },
    mapTukuTab() {
      return mapTukuTab({
        tukuTabs: this.tukuTabs,
        cpTypeDetail: this.cpTypeDetail,
        baseUrl: '/m/images'
      })
    }
  },
  watch: {
    show(val) {
      this.openPopUp = val
    }
  },
  methods: {
    back() {
      this.openPopUp = false
      this.$emit('update:show', this.openPopUp)
    },
    getContainer() {
      return document.querySelector('.layout-main')
    },
    async switchLottery(item) {
      this.$emit('switchLottery', item)
      if (!item.natureLink) {
        console.warn('switchLottery: 項目缺少 natureLink 參數!', item)
        return
      }
      const { natureLink } = item
      window.location.href = natureLink
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .van-nav-bar__text {
  color: #fff;
}
/deep/ .van-nav-bar .van-icon {
  color:  #fff;
}
/deep/ .van-nav-bar__title {
  color:  #fff;
  font-size: 0.48309rem;
}
.van-popup.van-popup--bottom {
  display: flex;
  flex-direction: column;
}
.wrap {
  width: 100%;
  overflow-y: auto;
}
.filter {
  border-bottom: 1px solid #e4e3e8;
  padding-bottom: 13px;
}
.filter .filter-title {
  padding: 0px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
}
.filter .filter-icon {
  width: 24PX;
  height: 24PX;
  flex-shrink: 0;
  margin-right: 8PX;
}
.filter .filter-title .title-lt {
  font-size: 16px;
  margin: 0px;
  line-height: 40px;
}
.filter .filter-game {
  margin: 0;
  padding: 0;
  overflow: hidden;
  list-style: none;
  padding: 0px 12px;
  display: -ms-grid;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.filter .filter-game__item .item-link {
  display: -ms-grid;
  display: grid;
  text-align: center;
  text-decoration: none;
  background-color: #fff;
  position: relative;
  border-radius: 0.02rem;
  border: 1px solid #e5e4e9;
  color: #666666;
  font-size: 14px;
  padding: 10px 4px;
  white-space: normal;
  font-weight: normal;
  place-content: center;
  height: 100%;
}
</style>
